if (document.querySelectorAll('#leadership-intro-lottie').length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById('leadership-intro-lottie'), // Required
    path: 'assets/animations/bod.json', // Required
    renderer: 'canvas', // Required
    loop: true,
    autoplay: true,
    name: "Leadership-intro",
  })
}
